import {Term} from '../../terms/components/TermsComponent';

export const transferOfData: Term[] = [
  {
    id: '7.1',
    term:
      'Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those from your jurisdiction. Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer. We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy.',
  },
];
